import React from "react";
import CrudPage from "../../components/admin/CrudPage";

const STATUS_OPTIONS = [
  { value: "pending", label: "Pendiente" },
  { value: "in_transit", label: "En tránsito" },
  { value: "delivered", label: "Entregado" },
];
const STATUS_MAP = {
  pending: { label: "Pendiente", color: "amber" },
  in_transit: { label: "En tránsito", color: "blue" },
  delivered: { label: "Entregado", color: "green" },
};

const config = {
  title: "Envíos",
  eyebrow: "Logística",
  resource: "shipments",
  columns: [
    { key: "tracking", label: "Tracking" },
    { key: "client_name", label: "Cliente" },
    { key: "origin", label: "Origen" },
    { key: "destination", label: "Destino" },
    { key: "carrier", label: "Operador" },
    { key: "cold_chain", label: "Cadena fría", type: "bool" },
    { key: "status", label: "Estado", type: "status", statusMap: STATUS_MAP },
  ],
  fields: [
    { key: "tracking", label: "# Tracking", required: true },
    { key: "client_name", label: "Cliente", required: true },
    { key: "order_id", label: "Pedido relacionado (id)" },
    { key: "origin", label: "Origen", required: true },
    { key: "destination", label: "Destino", required: true },
    { key: "carrier", label: "Operador (Estafeta, DHL…)" },
    { key: "status", label: "Estado", type: "select", options: STATUS_OPTIONS, required: true },
    { key: "cold_chain", label: "Cadena fría", type: "checkbox", checkboxLabel: "Requiere refrigeración" },
  ],
};

export default function AdminShipments() {
  return <CrudPage config={config} />;
}
